import axios from "./../../config/axios";

function findByID(id) {
    return axios().get(`/purchase/purchase-orders/${id}`);
}

function create(data) {
    return axios().post("/purchase/purchase-orders", data, {
        headers: {
            "X-Request-ID": data.idempotentKey
        }
    });
}

function update(data) {
    return axios().put(`/purchase/purchase-orders/${data.id}`, data);
}

function close(data) {
    return axios().put(`/purchase/purchase-orders/${data.id}/close`);
}

function closeBulk(data) {
    return axios().put(`/purchase/close-bulk-purchase-orders`, data);
}

function remove(data) {
    return axios().delete(`/purchase/purchase-orders/${data.id}`);
}

function index(params) {
    params = {...params, limit: params.itemsPerPage, offset: (params.page - 1) * params.itemsPerPage};
    return axios().get("/purchase/purchase-orders", {
        params
    })
}

function listByRequisition(requsitionId) {
    return axios().get("/purchase/purchase-orders", { params: {
        requisition_id: requsitionId
    }})
}

function states() {
    return axios().get("/purchase/purchase-orders-states");
}

function print(id) {
    return axios().get(`/purchase/purchase-orders/${id}/print`, {
        headers: {
            "Accept": "text/html"
        }
    });
}

export default {
    findByID,
    create,
    update,
    closeBulk,
    remove,
    index,
    close,
    states,
    listByRequisition,
    print
}